import ConverterClass from '../../utils/converter';

class Converter extends ConverterClass {
    determinantTypes2Client = (data) => data
}

export default new Converter();
